import { createContext } from "react";
import { PageProps } from "gatsby";

export const PageMetadataContext = createContext({
  slug: undefined as string | undefined,
  location: undefined as PageProps["location"] | undefined,
  breadcrumbs: undefined as
    | {
        url: string;
        title: string;
      }[]
    | undefined,
});
